// Components==============
import { faArrowRight, faSignOut } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useParams } from 'react-router-dom';
import './FinishedButtons.module.scss';
// =========================

export default function AudioFinishedButtons() {
    const audioExercises = useSelector(
        (state: ReduxStore) => state.authentication?.user?.audio_exercises
    );

    const { exerciseId } = useParams() as { exerciseId: string };

    const currentIndex = audioExercises?.findIndex(
        (e) => e.id === parseInt(exerciseId)
    );

    const nextExercise =
        typeof currentIndex === 'number' && audioExercises?.[currentIndex + 1];

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            styleName="wrapper"
        >
            <NavLink to="/">
                <button type="button">
                    <FontAwesomeIcon styleName="sign-out" icon={faSignOut} />
                    Terug naar kaart
                </button>
            </NavLink>
            {nextExercise && (
                <NavLink
                    to={`/${nextExercise?.treatment_id}/audio-exercise/${nextExercise?.id}`}
                >
                    <button type="button">
                        Door naar volgende audio-oefening
                        <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                </NavLink>
            )}
        </motion.div>
    );
}
